import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esPtsd } from "@/pages/es/esConditionData2";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute("/es/ptsd-treatment-coral-springs-fl")({
  head: () => buildEsConditionHead(esPtsd),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esPtsd} />;
}
